import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { basename } from "../../../config";

export default function Counter({
  counterValue,
  setCounterValue,
  idv,
  qouteCreated,
}) {
  const [count, setCount] = useState(0);

  const handleInputChange = (event) => {
    const inputValue = event?.target?.value ?? 0;
    const numericValue = inputValue.replace(/\D/g, "");
    console.log(numericValue, "vlaue handel", event, " dddd", inputValue);
    if (0 < parseInt(numericValue) <= 99) setCount(parseInt(numericValue));
  };

  console.log(idv, "idv is ", count);
  useEffect(() => {
    const obj = { ...counterValue, [idv]: count };
    setCounterValue(obj);
  }, [count]);

  return (
    <div className="d-flex " style={{ marginLeft: "27px" }}>
      <button
        className="value-button"
        id="decrease"
        style={{
          backgroundColor: "#d62828",
          borderRadius: "10px 0 0 10px",
          height: "30px",
          padding: "0px",
        }}
        disabled={count === 0 || qouteCreated ? true : false}
        onClick={() =>
          setCount((prev) => {
            if (prev === 0) {
              return 0;
            } else {
              return prev - 1;
            }
          })
        }
      >
        <img
          src={`/${basename}/Assets/Images/minusIconFCL.png`}
          alt="add icon"
          style={
            qouteCreated
              ? {
                  height: "18px",
                  opacity: "0.3",
                }
              : {
                  height: "18px",
                }
          }
        />
        {/* <RemoveIcon /> */}
      </button>
      <input
        style={{ width: "40px", height: "30px" }}
        id="number"
        min={0}
        max={100}
        maxLength="2"
        type="text"
        value={isNaN(count) ? 0 : count}
        onChange={handleInputChange}
      />
      <button
        className="value-button"
        id="inccrease"
        style={{
          backgroundColor: "#90a955",
          borderRadius: "0px 10px 10px 0px",
          height: "30px",
        }}
        disabled={count === 99 || qouteCreated ? true : false}
        onClick={() =>
          setCount((prev) => {
            if (prev === 99) {
              return 99;
            } else {
              return prev + 1;
            }
          })
        }
      >
        <img
          src={`/${basename}/Assets/Images/addIconFCL.png`}
          alt="add icon"
          style={
            qouteCreated
              ? {
                  height: "18px",
                  opacity: "0.3",
                }
              : {
                  height: "18px",
                }
          }
        />
        {/* <AddIcon /> */}
      </button>
    </div>
  );
}
